module.exports = __webpack_public_path__ + "static/img/图标@2x.0c2f9fb8.png";